<!--
 * @Description: 备课
 * @Author: 王赵坤
 * @Date: 2022-10-28 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2024-07-26 09:12:50
-->
<template>
  <div class="list-page pl0 pt0 pr0 pb0">
    <el-container>
      <el-main>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="学期">
                <span>{{xqmc}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程">
                {{bjlist[0].kcmc}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="周次">
                <span>第{{zc}}周</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="班级/节次">
                <div v-for="item in chechboxtrue" :key="item.id" class="banjibox">
                  <span>{{item.bjmc}}/星期{{item.xq}}第{{item.jc}}节<br></span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学单元" prop="jxdyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                  <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:bjlist[0].kcid,kcmc:bjlist[0].kcmc}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学内容" prop="jxnrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                  <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:bjlist[0].kcid,kcmc:bjlist[0].kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="批评与建议">
                <el-input v-model="ruleForm.ppyjy" type="textarea" resize="none" :autosize='{minRows: 4, maxRows: 4}' />
              </el-form-item>
            </el-col> -->
            <el-col :span="24" v-for="(item, index) in ruleForm.jxsjmb" :key="index">
              <el-form-item :label="item.mbzdmc" :prop="'jxsjmb.' + index + '.nr'" :rules="item.sfbt ? [{required: true,message:  '必填项',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                <el-input v-if="item.zdlx===1" v-model="item.nr" type="textarea" :rows="1" />
                <div v-if="item.zdlx===2">
                  <ueditor v-model:value="item.nr" :row="{height:350}" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer class="el-dialog__footer">
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" v-if="sfwcbc" @click="submit()">保存 </el-button>
            <el-button type="primary" v-if="sfwctj" @click="submitTj()">保存并提交</el-button>
            <el-button @click="handleClose">关闭</el-button>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { getDate } from '@/utils/index'
import { closeWindow, loadSelect, actionPost } from '@/api/common.js'
import jiaoxuedanyuan from './jiaoxuedanyuan.vue'
import jiaoxueneirong from './jiaoxueneirong.vue'
import ueditor from '@/components/ueditor.vue'

const emits = defineEmits(['update:openAdd', 'ReturnData', 'guanbi'])
const props = defineProps({
  openAdd: { type: Boolean, required: true },
  row: { type: Object, required: false },
  chechboxtrue: { type: Array, required: false }
})

// 关闭
const handleClose = () => {
  closeWindow('openAdd', emits, true)
  emits('update:openAdd', false)
  emits('guanBi', true)
}
const ruleFormRef = ref(null)
const ruleForm = ref({})

const row = ref()
// 获取备课模板
const getjxsjmblist = () => {
  const o = { url: '/api/v2/jiaowu/beikemuban/beikemuban/list', data: {} }
  actionPost(o).then((res) => {
    ruleForm.value.jxsjmb = res.data
  })
}

// 查询教学单元
const jxdyData = ref([])
const bjlist = ref([])
const keChengChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: bjlist.value[0].kcid, order: 'sx', sort: 'asc' }
  })
}
// 查询教学内容
const jxnrData = ref([])
const danDuanChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}

const openAddJiaoXueDanYuan = ref(false) // 添加教学单元
const openAddJiaoXueNeiRong = ref(false) // 添加教学内容

// 开设机构
const xqid = ref()
const xqmc = ref()
const zc = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      xqmc.value = props.row.xqmc
      xqid.value = props.row.xqid
      zc.value = props.row.zc
      getjxsjmblist()
    }
  },
  { deep: true, immediate: true }
)

watch(
  () => props.chechboxtrue,
  () => {
    if (props.chechboxtrue) {
      bjlist.value = props.chechboxtrue
      keChengChange()
    }
  },
  { deep: true, immediate: true }
)

// 保存并提交
const sfwcbc = ref(true)
const sfwctj = ref(true)
const submitTj = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()

  const data = {
    xqid: xqid.value,
    jxsjbjcks: [],
    jxsjnrs: ruleForm.value.jxsjmb,
    zc: zc.value,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    // ppyjy: ruleForm.value.ppyjy,
    zt: 2,
    tjsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm', 'ss')
  }
  bjlist.value.forEach((item) => {
    const obj = {
      xlbjkbid: item.xlbjkbid,
      bjid: item.bjid,
      kcid: item.kcid,
      xq: item.xq,
      jc: item.jc
    }
    data.jxsjbjcks.push(obj)
  })
  const o = { url: '/api/v2/jiaowu/jiaowubeike/tijiaobeike', data: data }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      sfwcbc.value = false
      sfwctj.value = false
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 保存
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()

  const data = {
    xqid: xqid.value,
    jxsjbjcks: [],
    jxsjnrs: ruleForm.value.jxsjmb,
    zc: zc.value,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    zt: 1,
    tjsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm', 'ss')
  }
  bjlist.value.forEach((item) => {
    const obj = {
      xlbjkbid: item.xlbjkbid,
      bjid: item.bjid,
      kcid: item.kcid,
      xq: item.xq,
      jc: item.jc
    }
    data.jxsjbjcks.push(obj)
  })

  const o = { url: '/api/v2/jiaowu/jiaowubeike/baocunbeike', data: data }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      sfwcbc.value = false
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}

</script>
<style lang="less" scoped>
.banjibox {
  width: 300px;
  display: flex;
  flex-direction: column;
}
.fwb {
  width: 400px;
}
</style>
